import { SET_B2C_BETA_USER, SET_B2C_STATE } from "../types";

const initialState = {
  data: {},
  isBetaUser: false,
};

const b2cReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_B2C_STATE:
      return {
        ...state,
        data: action.payload,
      };
    case SET_B2C_BETA_USER:
      return {
        ...state,
        isBetaUser: action.payload,
      };
    default:
      return state;
  }
};

export default b2cReducer;
